import { render, staticRenderFns } from "./ClientAccount.vue?vue&type=template&id=3a8e00c8&scoped=true"
import script from "./ClientAccount.vue?vue&type=script&lang=js"
export * from "./ClientAccount.vue?vue&type=script&lang=js"
import style0 from "./ClientAccount.vue?vue&type=style&index=0&id=3a8e00c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e00c8",
  null
  
)

export default component.exports